import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=36dd4c08"
import script from "./testIndex.vue?vue&type=script&lang=js"
export * from "./testIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36dd4c08')) {
      api.createRecord('36dd4c08', component.options)
    } else {
      api.reload('36dd4c08', component.options)
    }
    module.hot.accept("./testIndex.vue?vue&type=template&id=36dd4c08", function () {
      api.rerender('36dd4c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/floorPlan/testIndex.vue"
export default component.exports